import { deprecate } from '../../lib/utils';
import connectRange from '../range/connectRange';

export default deprecate(connectRange, '\'connectRangeSlider\' was replaced by \'connectRange\'.\n  Please see https://community.algolia.com/instantsearch.js/v2/connectors/connectRange.html');


//////////////////
// WEBPACK FOOTER
// ./node_modules/instantsearch.js/es/connectors/range-slider/connectRangeSlider.js
// module id = null
// module chunks = 